export const GIRL_CODE_LOGO_URL =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_youth-center-stl/artifacts/ucafash0_0f70e718-64d2-4d4c-89a5-731d6f50b3e5.png";